import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useCancelUnavailabilityMutation } from '../../Api/unavailability';
import useTranslate from '../../Hooks/useTranslate';
import Button from '../../Style-guide/Button';
import Modal from '../../Style-guide/Modal';
import Text from '../../Style-guide/Text';
import Title from '../../Style-guide/Title';

const PeriodsDisplay = ({ data, courtId }) => {
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const [removablePeriodId, setRemovablePeriodId] = useState(null);
  const queryClient = useQueryClient();
  const periods = data || [];
  const tr = useTranslate();

  const { mutate: cancelRequest, isSuccess } = useCancelUnavailabilityMutation();

  useEffect(() => {
    if (isSuccess) {
      queryClient.invalidateQueries({
        queryKey: ['unavailable-periods'],
      });
    }
  }, [isSuccess, queryClient]);

  const formatDate = (periodString) => {
    const period = new Date(periodString);
    const day = String(period.getDate()).padStart(2, '0');
    const month = String(period.getMonth() + 1).padStart(2, '0');
    const year = period.getFullYear();
    const hours = String(period.getHours()).padStart(2, '0');
    const minutes = String(period.getMinutes()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  return (
    <section className='unavailable-periods-container'>
      <Title size='MD' className='unavailable-periods-title'>
        {tr('unavailable_periods')}
      </Title>
      <div className='unavailable-periods-content'>
        {periods.map((date) => (
          <div
            key={date.id}
            className={`period-row ${Date.now() > new Date(date.endDate) ? 'outdated-period' : ''}`}
          >
            <Text size='SM' className='period-text'>
              {formatDate(date.startDate)}
            </Text>
            <Text size='SM' className='period-text'>
              -
            </Text>
            <Text size='SM' className='period-text'>
              {formatDate(date.endDate)}
            </Text>
            <Button
              $negativeAction
              className='cancel-btn'
              onClick={() => {
                setIsCancelModalOpen(true);
                setRemovablePeriodId(date.id);
              }}
            >
              {tr('cancel')}
            </Button>
          </div>
        ))}
      </div>

      <Modal
        show={isCancelModalOpen}
        onClose={() => setIsCancelModalOpen(false)}
        confirmation
        question={tr('make_period_available_again')}
        confirmText={tr('yes')}
        cancelText={tr('no')}
        onConfirm={() =>
          cancelRequest({
            params: { courtId, periodId: removablePeriodId },
          })
        }
      />
    </section>
  );
};

export default PeriodsDisplay;
